// src/lib/erx.js
// Vendor-agnostic e-prescribing registry.
//
// The active vendor is selected at BUILD TIME via REACT_APP_ERX_VENDOR
// ('dosespot' | 'mdtoolbox'). Defaults to 'dosespot' so existing behavior
// is unchanged until the flag is flipped in the GitHub Actions secrets.
//
// Each vendor entry:
//   id           — vendor key
//   label        — display name for UI (modal header, error messages)
//   authEndpoint — apiFetch path returning SSO/session config
//   syncEndpoint — apiFetch path that creates the patient on the vendor side
//   patientIdKey — key in auth/sync responses holding the vendor patient id
//   buildSsoUrl(authData, externalPatientId) — full iframe URL, or null if
//                  the vendor is not yet configured.

const VENDORS = {
  dosespot: {
    id: 'dosespot',
    label: 'DoseSpot',
    authEndpoint: 'dosespot-auth',
    syncEndpoint: 'dosespot-sync-patient',
    patientIdKey: 'dosespot_patient_id',
    // Matches the original ERxModal URL construction exactly.
    buildSsoUrl(authData, externalPatientId) {
      if (!authData?.baseUrl) return null;
      const params = new URLSearchParams({
        SingleSignOnClinicId:     authData.clinicId    || '',
        SingleSignOnUserId:       authData.clinicianId || '',
        SingleSignOnPhraseLength: '32',
        SingleSignOnCode:         authData.token       || '',
      });
      if (externalPatientId) params.set('PatientId', String(externalPatientId));
      return `${authData.baseUrl}/LoginSingleSignOn?${params.toString()}`;
    },
  },

  mdtoolbox: {
    id: 'mdtoolbox',
    label: 'MDToolbox-Rx',
    authEndpoint: 'mdtoolbox-auth',
    syncEndpoint: 'mdtoolbox-sync-patient',
    patientIdKey: 'mdtoolbox_patient_id',
    // TODO(mdtoolbox): finalize once MDToolbox API docs arrive (sent after
    // demo/trial signup — see mdtoolbox-erx-scaffold.md). MDToolbox embeds
    // via iframe/browser object with an SSO handoff; the exact URL shape and
    // token scheme must come from their integration guide. DO NOT guess.
    buildSsoUrl(authData /* , externalPatientId */) {
      if (!authData?.ssoUrl) return null; // server returns the full URL once wired
      return authData.ssoUrl;
    },
  },
};

export const ERX_VENDOR_ID =
  (process.env.REACT_APP_ERX_VENDOR || 'dosespot').toLowerCase();

export function getErxVendor() {
  return VENDORS[ERX_VENDOR_ID] || VENDORS.dosespot;
}
